import type { PricebookRule } from '@/api/pricebook';

type RuleGroup = { rules?: PricebookRule[] };

// The search endpoint returns rules grouped per repairer pricebook
// (`[{ id, name, company_name, rules: [...] }]`) — never a flat rule array.
// Each group's own `id` is the pricebook UUID, not a rule id, so it must not be
// used to delete a rule. Flatten down to the inner rules, which carry the real
// numeric rule `id`. A flat-rule payload is passed through unchanged.
export const extractRules = (payload: unknown): PricebookRule[] => {
    const items = Array.isArray(payload)
        ? payload
        : ((payload as RuleGroup | null | undefined)?.rules ?? []);
    if (!Array.isArray(items)) return [];
    return items.flatMap((item) =>
        item && typeof item === 'object' && Array.isArray((item as RuleGroup).rules)
            ? ((item as RuleGroup).rules as PricebookRule[])
            : [item as PricebookRule],
    );
};
